<template>
  <div class="home">
    <van-button @click="$router.push({ name: 'reportIndex' })" type="primary"
      >报告查询-首页</van-button
    >
    <van-button
      @click="$router.push({ name: 'variationDetails' })"
      type="primary"
      >报告查询</van-button
    >

    <van-button @click="$router.push({ name: 'chemotherapy' })" type="primary"
      >主要按钮</van-button
    >
    <van-button @click="$router.push({ name: 'embryoDetails' })" type="primary"
      >胚系变异详情</van-button
    >
    <van-button @click="$router.push({ name: 'zixun' })" type="primary"
      >咨询</van-button
    >
    <div @click="dataCount()">数据统计</div>
    <div @click="dataLine()">数据统计-突变</div>

    <div class="canvas">
      <canvas
        id="canvas"
        width="300"
        height="300"
        style="border: 1px solid black"
      ></canvas>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "Home",
  components: {},
  data() {
    return {
      positions: "",
    };
  },
  mounted() {
    const img = new Image();
    const canvas = document.querySelector("#canvas");
    let ctx;
    ctx = canvas.getContext("2d");
    // 当图片加载完再动手
    img.onload = function () {
      // 画布大小和图片尺寸不一样算好比例
      const cWidth = canvas.width, cHeight = canvas.height;
      const imgWidth = img.naturalWidth, imgHeight = img.naturalHeight;
      const zoom = {
        width: cWidth / imgWidth,
        height: cHeight / imgHeight,
      };
      // 以图画底
      ctx.drawImage(img, 0, 0, cWidth, cHeight);
      // 假设左上角的point 29,24 这是针对原图的坐标系
      // 假设右下角的point 124,52 这是针对原图的坐标系
      const startPoint = [29, 24],endPoint = [124, 52];
      const startPoint1 = [49, 44],endPoint1 = [144, 92];
      // https://developer.mozilla.org/zh-CN/docs/Web/API/CanvasRenderingContext2D/strokeRect
      ctx.strokeStyle = "red";
      ctx.strokeRect(
        startPoint[0] * zoom.width,
        startPoint[1] * zoom.height,
        (endPoint[0] - startPoint[0]) * zoom.width,
        (endPoint[1] - startPoint[1]) * zoom.height
      );
      ctx.strokeRect(
        startPoint1[0] * zoom.width,
        startPoint1[1] * zoom.height,
        (endPoint1[0] - startPoint1[0]) * zoom.width,
        (endPoint1[1] - startPoint1[1]) * zoom.height
      );
    };

    // 动手
    img.src = require("../assets/not.png");
  },
  methods: {
    dataCount() {
      this.$router.push({
        name: "dataStatistics",
        params: {},
      });
    },
    dataLine() {
      this.$router.push({
        name: "mutationfrequency",
        params: {},
      });
    },
  },
};
</script>
<style lang="less" scoped>
button {
  margin-right: 20px;
  margin-bottom: 10px;
}
.nav {
  width: 750px;
  height: 100px;
  background: #ccc;
}
</style>
